(function() {
  function openQuickViewByHandle(handle, triggerBtn) {
    if (!handle || !window.AT) return;

    window.AT.productsViewedQuickly = window.AT.productsViewedQuickly || {};
    triggerBtn.classList.add('pending');

    Promise.all([
      window.AT.loadPopupQuickView(),
      window.AT.productsViewedQuickly[handle] ||
        fetch('/products/' + handle + '?view=ajax-quick-view', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function(res) { return res.text(); })
    ])
      .then(function(results) {
        var popupLoaded = results[0];
        var htmlContent = results[1];

        if (popupLoaded && window.PopupQuickView && htmlContent) {
          window.PopupQuickView.open(htmlContent);
          window.AT.productsViewedQuickly[handle] = htmlContent;
        }
      })
      .catch(function(err) {
        console.error('Quick View error:', err);
      })
      .finally(function() {
        triggerBtn.classList.remove('pending');
      });
  }

  function bindQuickView(section) {
    var quickViewButtons = section.querySelectorAll('.js-select-product-quick-view');
    if (!quickViewButtons.length) return;

    quickViewButtons.forEach(function(btn) {
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;

        function tryOpen() {
          if (window.AT && window.AT.loadPopupQuickView) {
            openQuickViewByHandle(handle, btn);
          } else {
            setTimeout(tryOpen, 100);
          }
        }

        tryOpen();
      });
    });
  }

  function initSelectYourProduct(section) {
    if (!section) return;

    var tabs = section.querySelectorAll('.select-your-product-mobile-2026__tab');
    var panels = section.querySelectorAll('.select-your-product-mobile-2026__panel');

    if (!tabs.length || !panels.length) return;

    function activateTab(tab) {
      var target = tab.getAttribute('data-target');

      tabs.forEach(function(item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function(panel) {
        var isTarget = panel.id === target;
        panel.classList.toggle('is-active', isTarget);
        if (isTarget) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function(event) {
        var currentIndex = Array.prototype.indexOf.call(tabs, tab);
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          var next = tabs[(currentIndex + 1) % tabs.length];
          next.focus();
          activateTab(next);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          var prev = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
          prev.focus();
          activateTab(prev);
        }
      });
    });

    bindQuickView(section);
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.select-your-product-mobile-2026').forEach(initSelectYourProduct);
  });
})();
